import { render, staticRenderFns } from "./AuthCard.vue?vue&type=template&id=60eb537a&scoped=true&"
import script from "./AuthCard.vue?vue&type=script&lang=js&"
export * from "./AuthCard.vue?vue&type=script&lang=js&"
import style0 from "./AuthCard.vue?vue&type=style&index=0&id=60eb537a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eb537a",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFlex: require('@chakra-ui/vue').CFlex})
